import { applySteps } from '@/mocks/franchiseData';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function ApplyProcess() {
  return (
    <section id="apply-process" className="relative bg-white py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <ScrollReveal variant="fade-up">
            <div className="text-center mb-14">
              <p className="text-brand-brown text-sm tracking-widest mb-3 font-medium">申请流程</p>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-deep leading-tight">
                简单六步，开启您的健康事业
              </h2>
            </div>
          </ScrollReveal>

          <div className="relative">
            <div className="hidden lg:block absolute top-14 left-[8%] right-[8%] h-px bg-brand-cream" />

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
              {applySteps.map((step, index) => (
                <ScrollReveal key={step.step} variant="fade-up" delay={index * 100}>
                  <div className="text-center relative group">
                    <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-brand-deep text-white font-bold text-sm relative z-10 group-hover:bg-brand-dark transition-colors">
                      {index + 1}
                    </div>
                    <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3 rounded-xl bg-brand-light group-hover:bg-brand-cream transition-colors">
                      <i className={`${step.icon} text-brand-deep text-lg`} />
                    </div>
                    <h4 className="text-sm font-semibold text-brand-deep mb-2">{step.title}</h4>
                    <p className="text-gray-400 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}